import Link from 'next/link';

export function StoreBadge({
  href,
  ariaLabel,
  icon,
  topLine,
  storeName,
  external,
}: {
  href: string;
  ariaLabel: string;
  icon: React.ReactNode;
  topLine: string;
  storeName: string;
  external?: boolean;
}) {
  return (
    <Link
      href={href}
      aria-label={ariaLabel}
      {...(external ? { target: '_blank', rel: 'noopener' } : {})}
      className="bg-foreground hover:bg-foreground/90 flex h-12 w-[176px] items-center gap-2.5 rounded-xl px-3.5 transition-colors"
    >
      {icon}
      <div className="text-background">
        <p className="text-[8.5px] leading-none whitespace-nowrap opacity-70">
          {topLine}
        </p>
        <p className="text-[15px] leading-tight font-semibold whitespace-nowrap">
          {storeName}
        </p>
      </div>
    </Link>
  );
}
